import { Outlet } from "react-router";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
// import Toolbar from "@mui/material/Toolbar";

import { AlertBar } from "../AlertBar";
import SideMenu from "../SideMenu";
import TopMenu from "../TopMenu";

function Layout() {
	return (
		<Box sx={{ display: "flex" }}>
			<CssBaseline />
			<SideMenu />
			<Box sx={{ flexGrow: 1, bgcolor: "background.default" }}>
				<TopMenu />
				<AlertBar />
				<Box
					component="main"
					sx={{ flexGrow: 1, bgcolor: "background.default" }}
				>
					<Box sx={{ px: 4, py: 3 }}>
						<Outlet />
					</Box>
				</Box>
			</Box>
		</Box>
	);
}
export default Layout;
